import { publicShortUrlsApi } from '@/website/api/publicShortUrls'
import { computedAsync, type MaybeRef } from '@vueuse/core'
import { unref, type Ref } from 'vue'

export const usePublicShortUrlsAsync = (limit?: MaybeRef<number>, evaluating?: Ref<boolean>) => {
    return computedAsync(
        async (onCancel) => {
            const abtCtrl = new AbortController()

            onCancel(() => abtCtrl.abort())

            const [data] = await publicShortUrlsApi.getLatest(unref(limit), abtCtrl.signal)

            return data
        },
        [],
        { evaluating },
    )
}
